<div class="button-container" [class.is-mobile]="isMobile">
  <button (click)="scrollToTop()"><img src="assets/images/new-design-icons/arrow-scroll.svg" alt=""></button>
</div>
